import { useEffect, useState } from "react";

export type Theme = "light" | "dark" | "system";
const DEFAULT_THEME: Theme = "system";

export function useThemeState() {
  const [themeState, setThemeState] = useState<Theme>(
    (localStorage.getItem("theme") as Theme) ?? DEFAULT_THEME
  );

  function setTheme(newTheme: Theme) {
    localStorage.setItem("theme", newTheme);
    setThemeState(newTheme);
  }

  const rootClassList = document.documentElement.classList;

  useEffect(() => {
    rootClassList.remove("theme--light", "theme--dark");
    if (themeState !== "system") {
      rootClassList.add(`theme--${themeState}`);
    }
  }, [themeState, rootClassList]);

  return [themeState, setTheme] as const;
}
